import { Create, List, Personal } from "../Components/index.js";

export default [
    {
        path: "/vehicle/mp-report",
        component: List,
        name: "vehicle-mp-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/vehicle/mp-report/create",
        component: Create,
        name: "vehicle-mp-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/personal/mp-report/create",
        component: Personal,
        name: "personal-mp-create",
        meta: {
            requiresAuth: true,
        },
    },
];
